export default __webpack_public_path__ + "static/media/browse-candidate.81a3ca9b.png";